var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['indicator', _vm.status]})
}
var staticRenderFns = []

export { render, staticRenderFns }